import OurLetShift from "@/components/backoffice/all-staff/shift-schedule/our-let-shift";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import ShiftSettingsTabs from "@/components/backoffice/all-staff/shift-schedule/shift-settings-tabs";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import hasPermission from "@/hooks/hasPermission";

function ShiftSchedule() {
  const hasOutletShift = hasPermission("back_office.staff_management.out_let_shift");
  const hasShiftSettings = hasPermission("back_office.staff_management.shift_settings");

  const defaultTab = hasOutletShift ? "ourletshift" : (hasShiftSettings ? "shift-settings" : "");

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "Shift Schedule" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Staff Management",
          path: "/backoffice/staff-management/staff/all",
        },
        {
          name: "Shift Schedule",
          path: "/backoffice/staff-management/shift-schedule",
        },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-between items-start md:items-center md:flex-row flex-col gap-5  w-full"></div>
        <Tabs
          valueKey="staff-manage-shift-schedule"
          className="bg-transparent relative"
          defaultValue={defaultTab}
        >
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            {hasOutletShift && (
              <TabsTrigger className="bg-transparent" value="ourletshift">
                Outlet Shift
              </TabsTrigger>
            )}
            {hasShiftSettings && (
              <TabsTrigger value="shift-settings">Shift Settings</TabsTrigger>
            )}
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          {hasOutletShift && <OurLetShift />}
          {hasShiftSettings && <ShiftSettingsTabs />}
        </Tabs>
      </div>
    </Layout2>
  );
}

export default ShiftSchedule;
